/**
 * @file scanners-block.js
 */
import {getResultCountHtml} from "./view-helpers";

(function ($, Drupal, drupalSettings, once) {
  'use strict';

  function updateResultCount() {
    // Ensure we have results first
    let pagesCurrentItem = document.querySelector('.insights-display span[data-pages-current]');
    let resultsDisplay = document.getElementById('resultCount');

    if (pagesCurrentItem && resultsDisplay) {
      const pagesCurrent = parseInt(pagesCurrentItem.textContent);
      const itemsPerPage = parseInt(document.querySelector('.insights-display span[data-items-per-page]').textContent);
      const itemsTotal = parseInt(document.querySelector('.insights-display span[data-items-total]').textContent);
      resultsDisplay.innerHTML = getResultCountHtml(pagesCurrent, itemsPerPage, itemsTotal);
    } else {
      if (resultsDisplay) {
        resultsDisplay.innerHTML = '';
      }
    }
  }

  Drupal.behaviors.kodakScannersBlock = {
    attach: function (context, settings) {
      // Attach keydown event for the search input, using `once` to avoid multiple bindings
      once('scannersSearchInput', $('#scanners-search-input', context)).forEach((element) => {

        $(element).on('keydown', function (e) {
          if (e.key === 'Enter') {
            // Prevent the default Enter key action (form submit)
            e.preventDefault();

            $('[name="combine"]').val($(this).val());

            // Trigger the AJAX form submission
            $('[data-bef-auto-submit-click]').click();
          }
        });

        $('.scanners-search-button', context).on('click', function () {
          const searchInputValue = $('#all-search-input').val();
          $('[name="combine"]').val(searchInputValue);

          // Trigger the AJAX form submission
          $('[data-bef-auto-submit-click]').click();
        });

        updateResultCount();
      });
    }
  };

  // Re-apply the behavior and update result count on AJAX updates.
  $(document).ajaxComplete(function () {
    if ($('#scanners-search-input').length) {
      // Re-attach the behavior with the document context to handle all elements.
      Drupal.behaviors.kodakScannersBlock.attach(document, drupalSettings);
      // Call updateResultCount again to update the result count after AJAX completes
      updateResultCount();
    }
  });

})(jQuery, Drupal, drupalSettings, once);
